import axios from "axios"

const BOX_API_APPS_ENDPOINT = "https://api.box.com/2.0/apps"
const BOX_DEV_REVOKE_ENDPOINT = "/.netlify/functions/revoke-access-token"

const ACCESS_LEVELS = {
  auth_code_grant: {
    enterprise: "access_manage_any_app_user",
    application: "access_manage_own_app_user",
  },
  jwt_grant: {
    enterprise: "access_manage_any_app_user",
    application: "access_manage_own_app_user",
  },
  app_token_auth: {
    enterprise: "access_manage_app_content_only",
    application: "access_manage_app_content_only",
  },
}

const APP_TYPES = {
  auth_code_grant: "client_server",
  jwt_grant: "server_server",
  app_token_auth: "server_server",
}

/**
 * Parse and validate the props a user passed into this element
 */
export const parseProps = (props) => {
  const config = { ...props }
  // parse a comma seperated list of scopes to an actual list of scope objects
  config.scopes ||= ""
  config.scopes = config.scopes.split(",").map((scope) => ({ scope }))
  config.redirect_url = config.redirect_url.startsWith("http")
    ? config.redirect_url
    : `${process.env.GATSBY_URL}${config.redirect_url}`

  // lowercase the various enums
  config.authentication_type ||= "auth_code_grant"
  config.authentication_type = config.authentication_type.toLowerCase()
  config.app_type = APP_TYPES[config.authentication_type]
  config.access ||= "application"
  config.access = config.access.toLowerCase()
  // parse the access level
  config.access = ACCESS_LEVELS[config.authentication_type][config.access]
  // parse can_act_as_user as a boolean
  config.can_act_as_user = [true, ""].includes(config.can_act_as_user)
  return config
}

/**
 * Make a call to the Box API to create an app
 */
export const boxCreateApp = (props) => axios.post(
  BOX_API_APPS_ENDPOINT,
  {
    name: props.nameRef.current.value,
    app_type: props.app_type,
    authentication_type: props.authentication_type,
    scopes: props.scopes,
    can_act_as_user: props.can_act_as_user,
    access: props.access,
    redirect_uri: props.redirect_url,
    cors_origins: props.cors_origins,
  },
  {
    headers: {
      authorization: `Bearer ${props.boxCredentials.access_token}`,
      "content-type": "application/json",
    },
  },
)

/**
 * Make an API call to the Box API to revoke an access token
 */
export const boxRevokeToken = ({ boxCredentials, useCreateAppScope }) => axios.post(BOX_DEV_REVOKE_ENDPOINT, {
  accessToken: boxCredentials.access_token,
  useCreateAppScope,
})
